import React, { useState, useEffect } from "react";
import { useLazyQuery } from "@apollo/client";
import { Skeleton } from "@/components/ui/skeleton";
import { GET_ADDITIONAL_COMPONENTS_BY_CODES } from "@/components/queries/additionalComponentQueries";

interface ArmrestsConditionsTableProps {
  conditions: string[];
}

export default function ArmrestsConditionsTable({
  conditions,
}: ArmrestsConditionsTableProps) {
  const [loadComponents, { data, loading, error }] = useLazyQuery(
    GET_ADDITIONAL_COMPONENTS_BY_CODES
  );
  const [componentDetails, setComponentDetails] = useState<any[]>([]);

  useEffect(() => {
    if (conditions && conditions.length > 0) {
      loadComponents({
        variables: {
          codes: conditions,
        },
      });
    }
  }, [conditions, loadComponents]);

  useEffect(() => {
    if (data?.findManyAdditionalComponent) {
      setComponentDetails(data.findManyAdditionalComponent);
    }
  }, [data]);

  if (!conditions || conditions.length === 0) {
    return (
      <div className="text-muted-foreground text-sm pt-2">
        No armrest conditions
      </div>
    );
  }

  if (loading) {
    return (
      <div className="border rounded-md p-4">
        <div className="space-y-2">
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-full" />
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="text-red-500 text-sm pt-2">
        Error loading component details: {error.message}
      </div>
    );
  }

  return (
    <div className="border rounded-md p-4">
      <div className="grid grid-cols-3 gap-4 text-xs">
        <div>Image</div>
        <div>Name</div>
        <div>Code</div>

        {componentDetails.length > 0
          ? componentDetails.map((component) => (
              <React.Fragment key={component.id}>
                <div>
                  {component.image?.src_thumbnail && (
                    <img
                      src={
                        component.image.src_md || component.image.src_thumbnail
                      }
                      alt={
                        component.additional_component_profiles[0]?.name ||
                        component.code
                      }
                      className="w-12 h-12 object-cover rounded-md"
                    />
                  )}
                </div>
                <div>
                  {component.additional_component_profiles[0]?.name ||
                    "Unnamed Component"}
                </div>
                <div>{component.code}</div>
              </React.Fragment>
            ))
          : conditions.map((code, index) => (
              <React.Fragment key={index}>
                <div>-</div>
                <div>-</div>
                <div>{code}</div>
              </React.Fragment>
            ))}
      </div>
    </div>
  );
}
